import { useContext } from "react"
import { AuthContext, AuthContextType } from "../app-layout/context"
import { Navigate } from "react-router-dom"
import { useGetConfigs } from "./api"
import FormFields from "./components/FormFields"
import FormDialog from "./components/FormDialog"

const AdminOnboardView = () => {

  const { username } = useContext<AuthContextType>(AuthContext)

  if(username !== "testuser"){
    <Navigate to="/home" />
  }

  const { configFieldsData } = useGetConfigs()

  return (
    <div className="mt-[5vh] w-full sm:w-[calc(100%-4rem)] h-[95vh] min-h-[700px] overflow-hidden max-lg:overflow-x-hidden max-lg:overflow-auto p-1 md:p-4 pt-2">
      <div className="size-full overflow-auto">
        <div className="w-full flex items-center justify-between h-20">
          <h2 className="text-lg font-poppins pb-4 tracking-wide font-medium">Configure Onboarding Clients</h2>
          <FormDialog />
        </div>
        {configFieldsData &&
          <FormFields fields={configFieldsData.api_configs} />
        }
      </div>
    </div>
  )
}

export default AdminOnboardView
